import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'i18n';
import Spinner from 'components/spinners/InfiniteCircleDots';

import { mediaQueries } from 'styles/utils/mediaQueries';

export default function Placeholder() {
  return (
    <PlaceholderWrap>
      <MessageWrap>
        <FormattedMessage
          id={'searchingForPrices.label'}
          description={'Searching prices...'}
          defaultMessage={'Searching prices...'}
        />
      </MessageWrap>
      <SpinnerWrap>
        <Spinner />
      </SpinnerWrap>
    </PlaceholderWrap>
  );
}

const PlaceholderWrap = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.darkTransparent};
  animation: react-placeholder-pulse 1.5s infinite;
`;

const MessageWrap = styled.div`
  display: none;

  ${mediaQueries.fromAndAbove.desktop`
    display: inline-block;
    font-size: 2.0em;
  `}
`;

const SpinnerWrap = styled.div`
  display: inline-block;
  width: 54px;
  height: 18px;
  background: none;

  div {
    width: 4px;
    height: 4px;
    margin: 7px auto;
    font-size: 4px;
    color: ${({ theme }) => theme.colors.text.templates.header};
  }

  ${mediaQueries.fromAndAbove.desktop`
    display: none;
  `}
`;
